import { createBrowserRouter, Navigate } from "react-router-dom";
import { App } from "App";
import React from "react";

import { MainPage } from "pages/MainPage";
import { StocksPage } from "pages/StocksPage/StocksPage";
import { EmployeesPage } from "pages/EmployeesPage";
import { ClientsPage } from "pages/ClientsPage";
import { ExpensesPage } from "pages/ExpensesPage";
import { PricesPage } from "pages/PricesPage/PricesPage";
import { MovementReportPage } from "pages/Reports/MovementReportPage/MovementReportPage";
import Login from "pages/LoginPage";
import { PrintTemplatesPage } from "pages/PrintTemplatesPage";
import { ChequePrintTemplatesPage } from "pages/ChequePrintTemplatesPage";
import { DocumentPage } from "pages/DocumentPage";
import { ProfitReportPage } from "pages/Reports/ProfitReportPage/ProfitReportPage";

import PrivateRoute from "./PrivateRoute";
import LoginRoute from "./LoginRoute";

export enum ERoutes {
  LOGIN = "/login",
  ROOT = "/",
  REFERENCES = "references",
  PRODUCTS = "products",
  EMPLOYEES = "employees",
  MEASURE = "measure",
  PRINT_TEMPLATES = "print-templates",
  CHEQUE_PRINT_TEMPLATES = "cheque-print-templates",
  STOCK = "stock",
  CLIENTS = "clients",
  AGENTS = "agents",
  CASH_REGISTER = "cash-register",
  EXPENSES = "expenses",
  PRICES = "prices",
  STATIONS = "stations",
  REASONS = "reasons",
  ORDER_STATUS = "order-status",
  SMS_TEMPLATES = "sms-templates",
  PRESENT_CERTIFICATES = "present-certificates",
  PROMOCODES = "promocodes",
  PRODUCT_TAGS = "products-tags",
  DOCUMENTS = "documents/:id",
  RECEIPTS = "receipts",
  SALES = "sales",
  MOVEMENTS = "movements",
  WRITE_DOWNS = "write-downs",
  INVENTORY = "inventory",
  REFUND_TO_SUPPLIER = "refund-to-supplier",
  REPORTS = "reports",
  MOVEMENT = "movement",
  PROFIT = "profit",
}

export const router = createBrowserRouter([
  {
    path: ERoutes.ROOT,
    element: (
      <PrivateRoute>
        <App />
      </PrivateRoute>
    ),
    children: [
      {
        path: ERoutes.REFERENCES,
        element: null,
        children: [
          {
            path: ERoutes.PRODUCTS,
            element: <MainPage />,
          },
          {
            path: ERoutes.EMPLOYEES,
            element: <EmployeesPage />,
          },
          {
            path: ERoutes.MEASURE,
            element: null,
          },
          {
            path: ERoutes.PRINT_TEMPLATES,
            element: <PrintTemplatesPage />,
          },
          {
            path: ERoutes.CHEQUE_PRINT_TEMPLATES,
            element: <ChequePrintTemplatesPage />,
          },
          {
            path: ERoutes.AGENTS,
            element: null,
          },
          {
            path: ERoutes.CASH_REGISTER,
            element: null,
          },
          {
            path: ERoutes.CLIENTS,
            element: <ClientsPage />,
          },
          {
            path: ERoutes.EXPENSES,
            element: <ExpensesPage />,
          },
          {
            path: ERoutes.ORDER_STATUS,
            element: null,
          },
          {
            path: ERoutes.PRESENT_CERTIFICATES,
            element: null,
          },
          {
            path: ERoutes.PRICES,
            element: <PricesPage />,
          },
          {
            path: ERoutes.STOCK,
            element: <StocksPage />,
          },
          {
            path: ERoutes.STATIONS,
            element: null,
          },
          {
            path: ERoutes.SMS_TEMPLATES,
            element: null,
          },
          {
            path: ERoutes.PRODUCT_TAGS,
            element: null,
          },
          {
            path: ERoutes.PROMOCODES,
            element: null,
          },
          {
            path: ERoutes.REASONS,
            element: null,
          },
        ],
      },
      {
        path: ERoutes.DOCUMENTS,
        element: <DocumentPage />,
      },
      {
        path: ERoutes.REPORTS,
        element: null,
        children: [
          {
            path: ERoutes.MOVEMENT,
            element: <MovementReportPage />,
          },
          {
            path: ERoutes.PROFIT,
            element: <ProfitReportPage />,
          },
        ],
      },
    ],
  },
  {
    path: ERoutes.LOGIN,
    element: (
      <LoginRoute>
        <Login />
      </LoginRoute>
    ),
  },
  {
    path: "*",
    element: <Navigate to={ERoutes.ROOT} replace />,
  },
]);
